// Hand a wish from anywhere in the studio (e.g. the selected element) to the KI-Assistent.
let pending = null;
export const askAssistant = text => { pending = text; window.dispatchEvent(new Event('assistant-ask')); };
export const takeAsk = () => { const t = pending; pending = null; return t; };

// Running AI jobs, visible studio-wide: generation continues while the customer works in another panel.
const jobs = new Map(), watchers = new Set();
const publish = () => watchers.forEach(fn => fn([...jobs.values()]));
export const watchAiJobs = fn => { watchers.add(fn); fn([...jobs.values()]); return () => watchers.delete(fn); };
export const trackAiJob = async (promise, label) => {
  const id = Math.random().toString(36).slice(2);
  jobs.set(id, { id, label, started: Date.now() }); publish();
  try { return await promise; } finally { jobs.delete(id); publish(); }
};
